import { FC } from 'react';
import { Datagrid, EditButton, EmailField, List, TextField } from 'react-admin';

export const UsersList: FC = () => (
  <List title="Пользователи" filter={{}}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <TextField source="username" />
      <EmailField source="email" />
      <TextField source="phone" />
      <TextField source="role" />
      <EditButton />
    </Datagrid>
  </List>
);
